import styled from 'styled-components';
import {dFlexCenter, mobileMedia} from '../../../../../globalVariables/GlobalVariables';

export const actionsBar = styled.div`
    ${dFlexCenter};
    padding: var(--space-md) var(--space-md) var(--space-xl);
    gap: var(--space-lg);
    background: var(--TA-color-bg-base);
    ${mobileMedia} {
        padding-bottom: var(--space-3xl);
    }
`;
